import atp from './client';
const opts = {
    headers: {
        Accept: 'application/json',
    }
};
const apiType = 'atp';
export const deleteSession = async (endPoint, headers, logger) => {
    logger && atp.setLogger(logger);
    return atp.delete(endPoint, apiType, { headers: { ...opts.headers, ...headers } }, false);
};
